module.exports = __webpack_public_path__ + "img/cornus.830dcdb1.jpg";